export default {
  RESIZING_WIDGET: 'Resizing widget to',
  FULL_SCREEN: 'full screen',
  STANDARD_SCREEN: 'normal mode',
  ENABLED: 'enabled',
  DISABLED: 'disabled'
}